import { createContext, useState, useContext, useEffect, useCallback } from "react";
import { authApiInstance } from "../services/api_service";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);

  const fetchUser = async () => {
    try {
      const response = await authApiInstance.get("authentication/user/data");
      setUser(response.data);
    } catch (error) {
      console.error("Error fetching user data:", error);
      setError(error);
    }
  };

  const checkVerifyResponse = useCallback(async (response) => {
    if (response.status === 200) {
      setIsAuthenticated(true);
      setPermissions(response.data.permissions);
      await fetchUser();
    }
  }, []);

  const checkAuth = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await authApiInstance.get("authentication/user/verify");
      checkVerifyResponse(response);
      setIsAuthenticated(true);
    } catch (error) {
      const refreshSuccess = await tryToRefreshToken();
      if(refreshSuccess) {
        const response = await authApiInstance.get("authentication/user/verify");
        checkVerifyResponse(response);
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
        setError(error);
      }
    } finally {
      setLoading(false);
    }
  }, [checkVerifyResponse]);

  const tryToRefreshToken = async () => {
    try {
      await authApiInstance.post('/authentication/user/refresh');
      return true;
    } catch (error) {
      console.error("Unable to refresh token:", error);
      return false;
    }
  }

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return (
    <AuthContext.Provider value={{ 
      isAuthenticated, 
      loading, 
      permissions, 
      user,
      error,
      checkAuth,
      fetchUser
    }}>
      {children}
    </AuthContext.Provider>
  );
};